var chunkMapping = {
	"247": [
		40247
	],
	"2057": [
		89548
	],
	"4387": [
		24387
	],
	"6031": [
		36983,
		54659
	],
	"6963": [
		76082,
		85309
	],
	"6994": [
		45124
	]
};
var idToExternalAndNameMapping = {
	"24387": [
		"default",
		"./ReservationsRoutes",
		88794
	],
	"36983": [
		"default",
		"./orderRedux",
		59699
	],
	"40247": [
		"default",
		"./OrderSubtypeSelector",
		59699
	],
	"45124": [
		"default",
		"./orderRemoteReducer",
		59699
	],
	"54659": [
		"default",
		"./OrderApp",
		59699
	],
	"76082": [
		"default",
		"./integrationRedux",
		59699
	],
	"85309": [
		"default",
		"./IntegrationApp",
		59699
	],
	"89548": [
		"default",
		"./reservationRemoteReducer",
		88794
	]
};
var idToRemoteMap = {
	"24387": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 88794
		}
	],
	"36983": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"40247": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"45124": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"54659": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"76082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"85309": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59699
		}
	],
	"89548": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 88794
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}